import { render, staticRenderFns } from "./LexinKeyboardLangTir.vue?vue&type=template&id=528d8be7&"
import script from "./LexinKeyboardLangTir.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangTir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports